
import { defineComponent, reactive, ref, toRefs } from 'vue'
import jfshool from '@/api/jfschool'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store'
import { PlayCircleFilled } from '@ant-design/icons-vue'
import Card from './card.vue'
export default defineComponent({
  components: {
    PlayCircleFilled,
    Card
  },
  setup() {
    type pageDataType = {
      list: Array<any>
      total: number
      loading: boolean
    }
    const route = useRoute()
    const pageData: pageDataType = reactive({
      list: [],
      total: 0,
      loading: false
    })
    function getlist() {
      pageData.loading = true
      const data: any = {}
      data.data = {
        groupName: '',
        groupType: 1,
        pageNo: 1,
        pageSize: 100,
        show: 1
      }
      data.headers = {
        'Content-Type': 'application/json',
        appcode: store.state.pcqueryInfo.appcode
      }
      jfshool.getProjectCourse(data).then((res: any) => {
        const result = res.data
        pageData.list = result.data
        pageData.total = result.total
        pageData.loading = false
      })
    }

    function gotoSpecialCourse(item: any) {
      router.push({
        name: 'specialcourse',
        query: {
          ...route.query,
          groupCode: item.groupCode,
          groupName: item.groupName
        }
      })
    }
    getlist()
    return {
      ...toRefs(pageData),
      gotoSpecialCourse
    }
  }
})
